<script>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { assetURL } from '../../utils/url';

export default {
    components: {
        Swiper,
        SwiperSlide,
    },
    // methods: {
    //     getEstateList() {
    //         axios.get('/estates/getEstates').then((response) => {
    //             this.items = response.data
    //         });
    //     }
    // },
    // beforeMount() {
    //     this.getEstateList();
    // },
    data() {
        return {
            items: [],
            slidesPerView: 2,
            breakpoints: {
                320: {
                    spaceBetween: 10,
                    centeredSlides: false,
                },
                700: {
                    direction: 'horizontal',
                    centeredSlides: false,
                    spaceBetween: 10,
                    step: 1,
                    slidesPerView: 2,
                },
                992: {
                    slidesPerView: 2,
                },
                1200: {
                    slidesPerView: 2,
                },
            },
            banner1: `${assetURL}images/placeholder/thumbnail.png`,
            sub_banner1: `${assetURL}images/about-1.webp`,
            sub_banner2: `${assetURL}images/about-2.webp`,
        };
    },
};
</script>
<template>
    <div
        class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-[65%_35%] tw-mt-20 xl:tw-grid-cols-[60%_40%] tw-pt-12"
    >
        <div
            class="tw-pl-4 tw-pr-4 lg:tw-pl-16 2xl:tw-pl-24 xxl:tw-pl-28 tw-pb-14 tw-w-full lg:tw-w-auto xxxl:tw-w-[800px] tw-space-y-5 tw-ml-auto tw-mr-5"
        >
            <div class="tw-text-[14px] tw-mb-5 headline tw-font-extrabold">
                ABOUT US
            </div>
            <div
                class="tw-text-darkGreen tw-leading-10 tw-text-[32px] lg:tw-text-[40px] md:tw-text-3xl lg: xl:tw-text-32px tw-font-extrabold"
            >
                Ortigas Land is one of the pioneers in the Philippine real
                estate landscape.
            </div>
            <div class="tw-text-darkTeal tw-text-[20px]">
                It has been perfecting the art of life, work, and leisure by
                conceiving of and building master-planned developments that have
                become thriving communities over time — paradigms of excellence
                in the Philippine real estate landscape.
            </div>
        </div>
        <div class="tw-relative">
            <swiper
                :breakpoints="breakpoints"
                :centeredSlides="false"
                :slidesPerView="2"
                :spaceBetween="20"
                class="history-list__swiper"
            >
                <swiper-slide class="estates-list__slide">
                    <div class="swiper-content">
                        <img :src="sub_banner1" class="swiper-image" />
                    </div>
                </swiper-slide>
                <swiper-slide class="estates-list__slide">
                    <div class="swiper-content">
                        <img :src="sub_banner2" class="swiper-image" />
                    </div>
                </swiper-slide>
            </swiper>
        </div>
    </div>
    <div
        class="tw-relative tw-grid tw-grid-cols-1 lg:tw-grid-cols-[55%_45%] history-block lg:tw-max-w-[630px] lg:tw-mx-auto"
    >
        <div
            class="tw-w-full lg:tw-w-[630px] tw-h-auto tw-relative md:-tw-bottom-8 history-form__wrapper tw-ml-auto tw-mr-0 tw-mb-auto tw-mt-10 lg:tw-mt-[-145px] lg:tw-ml-[-95px]"
        >
            <div
                class="tw-bg-grey1 tw-p-10 tw-w-[90%] lg:tw-w-full mx-auto md:mx-0"
            >
                <div class="tw-mb-4">
                    <h1
                        class="tw-text-darkGreen tw-text-[32px] tw-leading-8 md:tw-text-[2rem] tw-font-extrabold tw-mb-9"
                    >
                        Our History
                    </h1>
                    <h5
                        class="tw-text-darkTeal tw-text-base tw-text-[20px] tw-w-full"
                    >
                        Established in 1931, Ortigas Land transformed the vast
                        landscape of raw land, into thriving and progressive
                        industrial, commercial, and residential centers. The
                        original Mandaloyon Estate covering an area of 4,033
                        hectares of land, is currently home to some of the
                        leading names in business, commercial, residential, and
                        educational institutions today.
                    </h5>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss">
#estatesList {
    width: 97vw;
    position: absolute;
    z-index: 6;
    bottom: 15vw;
}
.history-list__swiper {
    .swiper-wrapper {
        padding: 0px 0 40px 0;
    }
    .swiper-content {
        background-color: #f0f1f1;
        height: 65vw !important;
        max-width: fit-content;
    }
    .swiper-heading,
    .swiper-footer {
        padding: 15px;
    }
    .swiper-footer {
        position: relative;
        min-height: 190px;
    }
    .swiper-image {
        width: 100%;
        height: 100%;
        object-fit: cover;
        max-width: 100%;
    }
    .estates-list__slide:nth-of-type(even) {
        .swiper-content {
            margin-bottom: -40px;
            margin-top: 64px;
        }
    }

    .estates-list__slide:nth-of-type(odd) {
        .swiper-content {
            margin-top: 0px;
        }
    }
}
.history-list__swiper .swiper-image {
    max-height: fit-content;
}
.swiper__item-headerCategory {
    text-transform: uppercase;
    letter-spacing: 1.2px;
    margin-top: 8px;
}
.swiper__item-headerLink {
    text-decoration: none;
    display: block;
    float: right;
    position: absolute;
    right: 20px;
    bottom: 20px;
    &:hover,
    &:active,
    &:focus {
        color: #4a5846;
    }
}
@media (max-width: 640px) {
    .swiper-content {
        height: 480px !important;
        max-width: 202px;
    }
}
@media (min-width: 992px) {
    .estates__listing-page {
        height: 710px;
        min-height: auto;
    }
    #estatesList {
        width: 80vw;
        bottom: 0vw;
    }
    .history-list__swiper {
        .swiper-content {
            height: 40vw !important;
        }
    }
}

@media (min-width: 1200px) {
    #estatesList {
        width: 85vw;
        margin: 0 0 0 48px;
    }
    .estates__listing-page {
        height: 710px;
        min-height: auto;
    }
    .history-list__swiper {
        .swiper-content {
            height: 33vw !important;
        }
    }
}

@media (min-width: 1300px) {
    .history-list__swiper {
        .swiper-content {
            height: 28vw !important;
            max-height: 490px;
        }
    }
}
@media (min-width: 1800px) {
    .history-form__wrapper {
        margin-top: -265px;
    }
}
</style>
